module.exports = __webpack_public_path__ + "img/whatsapp-plus-cover.27920ab3.webp";